/* 
  All of the routes for the Soft UI Dashboard React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be hidden automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Layouts
import Home from "./layouts/Home"
import Nosotros from "./layouts/Nosotros"
import Productos from "./layouts/Productos"
import Servicios from "./layouts/Servicios"
import Recursos from "./layouts/Recursos"
import Emafluorc from "./layouts/Productos/celdasDistSec/emafluorc"
import Modulpack36R from "./layouts/Productos/celdasDistPri/modulpack36R"
import UnimetC from "./layouts/Productos/celdasDistPri/unimetC"
import UnimetD from "./layouts/Productos/celdasDistPri/unimetD"
import UnimetH from "./layouts/Productos/celdasDistPri/unimetH"
import VDH from "./layouts/Productos/mediaTension/VDH"
import VDH15 from "./layouts/Productos/mediaTension/VDH-15"
import VDHGSMI from "./layouts/Productos/mediaTension/VDH-GSMI"
import VE from "./layouts/Productos/mediaTension/VE"
import VEE from "./layouts/Productos/mediaTension/VEE"
import Capacitores from "./layouts/Productos/solucionesIntegrales/capacitores"
import EHouse from "./layouts/Productos/solucionesIntegrales/eHouse"
import SubestacionMovil from "./layouts/Productos/solucionesIntegrales/subestacionMovil"
import UMI from "./layouts/Productos/solucionesIntegrales/UMI"
import HVCB from "./layouts/Productos/altaTension/HVCB"
import SGE from "./layouts/Productos/altaTension/SGE"
import HVCB72DT from "./layouts/Productos/altaTension/HVCB72DT"


//import UsuarioNuevoApp from "layouts/usuariosApp/UsuarioNuevoApp";
const routes = [
  {
    type: "collapse",
    name: "Home",
    key: "home",
    route: "/sitio/",
    component: Home,
    hidden: true
  },
  {
    type: "collapse",
    name: "Nosotros",
    key: "nosotros",
    route: "/quienes-somos/",
    component: Nosotros,
    hidden: false
  },
  {
    type: "collapse",
    name: "Productos",
    key: "productos",
    route: "/productos/",
    component: Productos,
    hidden: false
  },
  {
    type: "collapse",
    name: "HVCB",
    key: "hvcb",
    route: "/productos/hvcb",
    component: HVCB,
    hidden: true
  },
  {
    type: "collapse",
    name: "HVCB 72 DT",
    key: "hvcb72",
    route: "/productos/hvcb72",
    component: HVCB72DT,
    hidden: true
  },
  {
    type: "collapse",
    name: "SGE",
    key: "sge",
    route: "/productos/sge",
    component: SGE,
    hidden: true
  },
  {
    type: "collapse",
    name: "Emafluorc",
    key: "emafluorc",
    route: "/productos/emafluorc",
    component: Emafluorc,
    hidden: true
  },
  {
    type: "collapse",
    name: "Modulpack36R",
    key: "modulpack36R",
    route: "/productos/modulpack36R",
    component: Modulpack36R,
    hidden: true
  },
  {
    type: "collapse",
    name: "UnimetC",
    key: "unimetC",
    route: "/productos/unimet-c",
    component: UnimetC,
    hidden: true
  },
  {
    type: "collapse",
    name: "UnimetD",
    key: "unimetD",
    route: "/productos/unimet-d",
    component: UnimetD,
    hidden: true
  },
  {
    type: "collapse",
    name: "UnimetH",
    key: "unimetH",
    route: "/productos/unimet-h",
    component: UnimetH,
    hidden: true
  },
  {
    type: "collapse",
    name: "VDH",
    key: "vdh",
    route: "/productos/vdh",
    component: VDH,
    hidden: true
  },
  {
    type: "collapse",
    name: "VDH-15",
    key: "vdh-15",
    route: "/productos/vdh-15",
    component: VDH15,
    hidden: true
  },
  {
    type: "collapse",
    name: "VDH-GSMI",
    key: "vdh-gsmi",
    route: "/productos/vdh-gsmi",
    component: VDHGSMI,
    hidden: true
  },
  {
    type: "collapse",
    name: "VE",
    key: "ve",
    route: "/productos/ve",
    component: VE,
    hidden: true
  },
  {
    type: "collapse",
    name: "VEE",
    key: "vee",
    route: "/productos/vee",
    component: VEE,
    hidden: true
  },
  {
    type: "collapse",
    name: "BancoCapacitores",
    key: "capacitores",
    route: "/productos/banco-capacitores",
    component: Capacitores,
    hidden: true
  },
  {
    type: "collapse",
    name: "E-House",
    key: "EHouse",
    route: "/productos/EHouse",
    component: EHouse,
    hidden: true
  },
  {
    type: "collapse",
    name: "Subestacion-Movil",
    key: "SubestacionMovil",
    route: "/productos/subestacion-movil",
    component: SubestacionMovil,
    hidden: true
  },
  {
    type: "collapse",
    name: "UMI",
    key: "umi",
    route: "/productos/umi",
    component: UMI,
    hidden: true
  },
  {
    type: "collapse",
    name: "Servicios",
    key: "servicios",
    route: "/servicios/",
    component: Servicios,
    hidden: false
  },
  {
    type: "collapse",
    name: "Recursos",
    key: "recursos",
    route: "/recursos/",
    component: Recursos,
    hidden: false
  },
];

export default routes;